var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "OvwImage",

    getDefaultProps () {
        return {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Icon/ovw-image</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fillRule="evenodd">
    <g id="Icon/ovw-image">
      <rect id="Rectangle-5" x="2" y="2" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-6" x="2" y="5" width="4" height="1"/>
      <rect id="Rectangle-5-Copy" x="2" y="2" width="1" height="16"/>
      <rect id="Rectangle-5-Copy-4" x="5" y="2" width="1" height="16"/>
      <rect id="Rectangle-5-Copy-14" x="2" y="8" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-39" x="2" y="11" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-11" x="12" y="2" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-10" x="12" y="5" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-9" x="12" y="2" width="1" height="16"/>
      <rect id="Rectangle-5-Copy-8" x="15" y="2" width="1" height="16"/>
      <rect id="Rectangle-5-Copy-15" x="12" y="8" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-43" x="12" y="11" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-3" x="7" y="2" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-7" x="7" y="5" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-2" x="7" y="2" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-5" x="10" y="2" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-18" x="7" y="8" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-17" x="7" y="5" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-16" x="10" y="5" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-30" x="7" y="8" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-29" x="10" y="8" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-49" x="7" y="11" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-38" x="2" y="14" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-42" x="2" y="17" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-47" x="12" y="14" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-45" x="12" y="17" width="4" height="1"/>
      <rect id="Rectangle-5-Copy-46" x="17" y="2" width="3" height="1"/>
      <rect id="Rectangle-5-Copy-13" x="17" y="2" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-44" x="17" y="5" width="3" height="1"/>
      <rect id="Rectangle-5-Copy-25" x="17" y="5" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-41" x="17" y="8" width="3" height="1"/>
      <rect id="Rectangle-5-Copy-40" x="17" y="8" width="1" height="3"/>
      <rect id="Rectangle-5-Copy-63" x="17" y="11" width="3" height="1"/>
      <rect id="Rectangle-5-Copy-64" x="17" y="14" width="3" height="1"/>
      <rect id="Rectangle-5-Copy-62" x="17" y="11" width="1" height="3"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/ui/images/ovw-image.svg